export default {
	er_cover_default_title: 'කාර්ය සාධන සමාලෝචනය',
	er_page_success_metrics: 'මෙම මාසයේ වෙනස් වූ දේ',
	er_page_success_metrics_range: 'මෙම කාලයේ වෙනස් වූ දේ',
	er_page_success_metrics_week: 'මෙම සතියේ වෙනස් වූ දේ',
	er_page_comparison: 'සංසන්දනාත්මක සාරාංශය',
	er_page_period_summary: 'මාස සාරාංශය',
	er_page_period_summary_range: 'කාල සාරාංශය',
	er_page_period_summary_week: 'සති සාරාංශය',
	er_page_each_month: 'සෑම මාසයක්ම',
	er_page_rooms: 'කාමර',
	er_rooms_note: '{month} හි සෑම කාමරයක්ම, හොඳම ලකුණු පළමුව.',
	er_page_shift_comparison: 'මුර සංසන්ධනය',
	er_page_shift_summary: 'මුර අනුව',
	er_page_response_time: 'සාමාන්‍ය ප්‍රතිචාර කාලය (මිනි)',
	er_page_avg_score: 'අත්දැකීම් ලකුණු',
	er_page_complaints_vs_visits: 'පැමිණිලි සහ සංචාර',
	er_page_performance_trends: 'කාර්ය සාධන ප්‍රවණතා',
	er_page_complaint_drivers: 'පැමිණිලි හේතු',
	er_board_working: '{month} හා සසඳන විට වැඩිදියුණුයි',
	er_board_attention: '{month} හා සසඳන විට අවධානය අවශ්‍යයි',
	er_board_empty: 'මෙම මාසයේ සැලකිය යුතු වෙනස්කම් නැත.',
	er_board_empty_range: 'මෙම කාලයේ සැලකිය යුතු වෙනස්කම් නැත.',
	er_board_empty_week: 'මෙම සතියේ සැලකිය යුතු වෙනස්කම් නැත.',
	er_findings_intro: '{month} සමඟ සංසන්දනය. සැලකිය යුතු වෙනස්කම් පමණක් පෙන්වයි.',
	er_verdict_improved: 'වැඩිදියුණුයි',
	er_verdict_watch: 'අවධානය අවශ්‍යයි',
	er_col_metric: 'මිනුම',
	er_col_avg: 'YTD සා.',
	er_col_lifetime_avg: 'ආරම්භයේ සිට සා.',
	er_comparison_note: 'YTD සාමාන්‍යය ජනවාරි සිට {month} දක්වා වූ අගයයි.',
	er_lifetime_note: 'ආරම්භයේ සිට යනු දත්ත ඇති පළමු දිනයේ සිට {month} දක්වා මාසික සාමාන්‍යයයි.',
	er_comparison_note_week: 'වාර්තා සතිය තෝරාගත් පෙර සතිය සමඟ සංසන්දනය කෙරේ.',
	er_period_only_note: 'අගයන් {month} සඳහා පමණි.',
	er_each_month_note: 'තෝරාගත් කාලයේ සෑම මාසයක්ම. දත්ත නැති මාසය හිස්ව පවතී.',
	er_col_inc_dec: 'වැඩි / අඩු',
	er_col_complaint: 'පැමිණිල්ල',
	er_col_qty: 'ගණන',
	er_total: 'එකතුව',
	er_metric_avg_score: 'අත්දැකීම් ලකුණු',
	er_metric_avg_response_time: 'සාමාන්‍ය ප්‍රතිචාර කාලය',
	er_metric_cleaner_arrivals: 'පිරිසිදු කරන්නන්ගේ පැමිණීම්',
	er_metric_supervisor_inspections: 'අධීක්ෂක පරීක්ෂා',
	er_metric_complaints_vs_visits_pct: 'පැමිණිලි vs. සංචාර (%)',
	er_metric_complaints: 'පැමිණිලි',
	er_metric_customer_visits: 'සංචාරයන්',
	er_metric_expired_slas: 'කල් ඉකුත් වූ SLA',
	er_unit_min: 'මිනි',
	er_stat_expected_sla: 'බලාපොරොත්තු SLA',
	er_stat_vs_minutes: '{month} හි {value} හා සසඳා',
	er_stat_vs_count: '{month} හි {value} හා සසඳා',
	er_label_complaints: 'පැමිණිලි',
	er_label_visits: 'සංචාරයන්',
	er_label_complaints_per_visits: 'පැමිණිලි / සංචාර',
	er_chart_ratio: 'පැමිණිලි-සංචාර අනුපාතය',
	er_chart_ytd_window: 'ජනවාරි සිට {month} දක්වා.',
	er_cv_formula: 'වැසිකිළි සංචාරවලින් බෙදූ පැමිණිලි, ප්‍රතිශතයක් ලෙස: ({complaints} ÷ {visits}) × 100 = {ratio}% {month} හි.',
	er_export_kpis_title: 'වාර්තාවේ ඇතුළත් දේ',
	er_export_kpis_desc: 'මේ සියල්ල වාර්තාවේ ඇත. එකක් ඉවත් කිරීමට එය නිවා දමන්න.',
	er_export_select_all: 'සියල්ල තෝරන්න',
	er_export_clear_all: 'සියල්ල හිස් කරන්න',
	er_export_summary: '{report} vs {compare}',
	er_export_period_title: 'වාර්තා කාලය',
	er_export_grain: 'වාර්තාව',
	er_export_grain_month: 'මාසය',
	er_export_grain_week: 'සතිය',
	er_export_week_starts: 'සතිය ආරම්භ වන්නේ',
	er_export_week_starts_sunday: 'ඉරිදා',
	er_export_week_starts_monday: 'සඳුදා',
	er_export_report_month: 'වාර්තා මාසය',
	er_export_from_month: 'සිට',
	er_export_to_month: 'දක්වා',
	er_export_period_note_range: 'වාර්තාව ආරම්භයේ සිට අවසානය දක්වා සෑම මාසයක්ම එකතු කරයි. සැසඳීම ක්‍රියාත්මක විට එම දිගින් යුත් පෙර කාලය භාවිත වේ. වසර මුල සිට සංඛ්‍යා තවමත් ජනවාරි සිට අවසන් මාසය දක්වාය.',
	er_export_summary_range: '{from} – {to}',
	er_export_summary_range_vs: '{from} – {to} vs {compare}',
	er_export_compare_range_note: 'එම දිගින් යුත් පෙර කාලය.',
	er_export_report_week: 'වාර්තා සතිය',
	er_export_compare_month: 'සසඳන්න',
	er_export_shift: 'මුරය',
	er_export_shift_all: 'සියලු මුර',
	er_export_no_shifts: 'මෙම අඩවියේ සක්‍රීය මුරයන් නැත.',
	er_export_render_failed: 'වාර්තාව නිවැරදිව සකස් කළ නොහැකි වූ බැවින් එය බාගත නොකළේය. පිටුව නැවුම් කර නැවත උත්සාහ කරන්න.',
	er_export_comparison: 'සංසන්දනය',
	er_export_include_previous: 'පෙර කාලය ඇතුළත් කරන්න',
	er_export_comparison_on: 'සක්‍රීය',
	er_export_comparison_off: 'අක්‍රීය',
	er_export_no_previous_data: 'මෙම කාලපරිච්ඡේදයට පෙර දත්ත නොමැති බැවින් සංසන්දනය කිරීමට කිසිවක් නැත.',
	er_export_compare_previous: 'පසුගිය මාසය',
	er_export_compare_previous_week: 'පසුගිය සතිය',
	er_export_compare_last_year: 'පසුගිය වසරේ එම මාසය',
	er_export_no_periods: 'වාර්තාවක් නිර්යාත කිරීමට මෙම ස්ථානයට අවම වශයෙන් මාසයක දත්ත අවශ්‍යයි.',
	er_export_no_periods_week: 'වාර්තාවක් නිර්යාත කිරීමට මෙම ස්ථානයට අවම වශයෙන් සතියක දත්ත අවශ්‍යයි.',
	er_export_period_note: 'දත්ත ඇති මාස පමණක් පෙන්වයි. වර්ෂය දක්වා අගයන් සැමවිටම ජනවාරි සිට වාර්තා මාසය දක්වා වේ.',
	er_export_period_note_week: 'දත්ත ඇති සති පමණක් පෙන්වයි. සංසන්දනය සැමවිටම පෙර සතියක් සමඟය.',
	er_export_period_note_single_week: 'දත්ත ඇති සති පමණක් පෙන්වයි.',
	er_find_response_time_title: 'සාමාන්‍ය ප්‍රතිචාර කාලය',
	er_find_response_time_change: '{previous} සිට {current} මිනිත්තු දක්වා වෙනස් විය ({change}).',
	er_find_avg_score_title: 'අත්දැකීම් ලකුණු',
	er_find_score_eased: '{previous} සිට {current} දක්වා පහත වැටුණි.',
	er_find_score_improved: '{previous} සිට {current} දක්වා ඉහළ ගියේය.',
	er_find_score_ytd_inline: 'වසර ආරම්භයේ සාමාන්‍යය {ytd} සමඟ ගැලපේ.',
	er_find_score_ytd_inline_range: 'ජනවාරි සිට {endMonth} දක්වා සාමාන්‍යයට සමානයි ({ytd}).',
	er_find_score_ytd_against: 'වසර ආරම්භයේ සාමාන්‍යය: {ytd}.',
	er_find_score_ytd_against_range: 'ජනවාරි සිට {endMonth} දක්වා සාමාන්‍යය: {ytd}.',
	er_find_complaints_ratio_title: 'පැමිණිලි-සංචාර අනුපාතය',
	er_find_complaints_ratio_improved: '{previous} සිට {current} දක්වා වැඩිදියුණු විය.',
	er_find_complaints_ratio_rose: '{previous} සිට {current} දක්වා වෙනස් විය.',
	er_nar_cv_year_improved: 'වැසිකිළි සංචාර හා සසඳන පැමිණිලි වසර පුරා {from} සිට {to} දක්වා වැඩිදියුණු විය.',
	er_nar_cv_year_rose: 'වැසිකිළි සංචාර හා සසඳන පැමිණිලි වසර පුරා {from} සිට {to} දක්වා ඉහළ ගියේය.',
	er_nar_cv_moved: 'වැසිකිළි සංචාර හා සසඳන පැමිණිලි {previous} සිට {current} දක්වා වෙනස් විය.',
	er_nar_cv_current: 'වැසිකිළි සංචාර හා සසඳන පැමිණිලි {current}කි.',
	er_nar_types_total: 'මුළු පැමිණිලි {total}.',
	er_nar_types_1: 'ප්‍රධාන පැමිණිල්ල: {a} ({ap}%).',
	er_nar_types_2: 'ප්‍රධාන පැමිණිල්ල: {a} ({ap}%), ඊළඟට {b} ({bp}%).',
	er_nar_types_3: 'ප්‍රධාන පැමිණිල්ල: {a} ({ap}%), ඊළඟට {b} ({bp}%) සහ {c} ({cp}%).',
	er_find_rooms_slowest: 'දිගම ප්‍රතිචාර කාලය ඇති කාමර මෙම මාසයේ: {rooms}.',
	er_find_rooms_slowest_range: 'දිගම ප්‍රතිචාර කාලය ඇති කාමර මෙම කාලයේ: {rooms}.',
	er_find_rooms_slowest_week: 'දිගම ප්‍රතිචාර කාලය ඇති කාමර මෙම සතියේ: {rooms}.',
	er_find_rooms_lowest_score: 'මෙම මාසයේ අඩුම ලකුණු සහිත කාමර: {rooms}.',
	er_find_rooms_lowest_score_range: 'අඩුම ලකුණු ඇති කාමර මෙම කාලයේ: {rooms}.',
	er_find_rooms_lowest_score_week: 'මෙම සතියේ අඩුම ලකුණු සහිත කාමර: {rooms}.',

	er_find_so_what_ratio: 'වෙනසෙහි වැඩි කොටස {rooms} වෙතින්ය.',
	er_find_so_what_type: 'ප්‍රධාන පැමිණිල්ල: {name} ({percent}%).',
	er_hot_slowest: 'දිගම ප්‍රතිචාර කාලය ඇති කාමර',
	er_hot_expired_slas: 'SLA ඉක්මවූ කාමර',
	er_hot_ratio: 'පැමිණිලි අනුපාතයේ විශාලතම වෙනස සහිත කාමර',
	er_hot_top_type: '"{name}" පැමිණිලි වැඩිම කාමර',
	er_hot_col_room: 'කාමරය',
	er_col_response: 'ප්‍රතිචාරය',
	er_col_cleaners: 'පිරිසිදු කරන්නන්',
	er_col_score: 'ලකුණු',
	er_chart_sla: 'SLA',
	er_hot_col_ratio: 'අනුපාතය',
	er_hot_col_change: 'වෙනස',
	er_hot_col_count: 'ගණන',
	er_hot_empty: 'මෙම මාසයේ කාමර මට්ටමේ ඉස්මතු කිරීම් නැත.',
	er_hot_empty_range: 'මෙම කාලයේ කාමර මට්ටමේ ඉස්මතු කිරීම් නැත.',
	er_hot_empty_week: 'මෙම සතියේ කාමර මට්ටමේ ඉස්මතු කිරීම් නැත.',
	er_cover_highlights: 'මෙම මාසය',
	er_cover_highlights_range: 'මෙම කාලය',
	er_cover_highlights_week: 'මෙම සතිය',
	er_cover_score_rose: 'අත්දැකීම් ලකුණු ඉහළ ගියේය.',
	er_cover_score_eased: 'අත්දැකීම් ලකුණු පහළ ගියේය.',
	er_cover_response_improved: 'ප්‍රතිචාර කාලය වැඩිදියුණු විය.',
	er_cover_response_slowed: 'ප්‍රතිචාර කාලය දිගු විය.',
	er_cover_ratio_fell: 'පැමිණීම්වලට සාපේක්ෂ පැමිණිලි අනුපාතය පහළ ගියේය.',
	er_cover_ratio_rose: 'පැමිණීම්වලට සාපේක්ෂ පැමිණිලි අනුපාතය ඉහළ ගියේය.',
	er_export_pdf: 'උපකරණ පුවරු PDF',
	er_export_executive: 'විධායක වාර්තාව',
	'executive-report': 'විධායක වාර්තාව',
	er_export_csv: 'CSV',
	er_export_status_title: 'වාර්තාව සකසමින්',
	er_export_status_fetch: 'සංඛ්‍යා ලබා ගනිමින්',
	er_export_status_layout: 'පිටු සකසමින්',
	er_export_status_page: 'පිටුව {page} / {total}',
	er_footer_copyright: 'මෙම වාර්තාව BuzzzTech පද්ධතිය හරහා සකසන ලදී.',
	er_contact_line: 'ප්‍රශ්න තිබේද නැතහොත් දත්ත තවදුරටත් ගවේෂණය කිරීමට අවශ්‍යද? BuzzzTech Customer Success කණ්ඩායම සම්බන්ධ කරගන්න: {email} හෝ {phone}.',
};
